import { getStringFromDateWithoutTime } from '@/lib/date'

export default {
    methods: {
        getDate(date) {
            return getStringFromDateWithoutTime(date, 'YYYY-MM-DD')
        },
    },
}
